import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { OperationsComponent } from '@emm/management/components/operations/operations.component';
import { NotificationService } from '@emm/shared/services/notification.service';

@Injectable({
    providedIn: 'root'
})
export class ConfirmOperationsDeactivateGuard implements CanDeactivate<OperationsComponent> {
    constructor(private notificationService: NotificationService) {}

    canDeactivate(
        component: OperationsComponent,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (component.isMovingChangeSets) {
            this.notificationService.error(
                'A reschedule is in progress. Please wait for it to complete before navigating away.'
            );
            return false;
        }
        return true;
    }
}
